import { Phone, MessageCircle, MapPin, Instagram } from "lucide-react";
import { PHONE_DISPLAY, PHONE_TEL, WA_DEFAULT, INSTAGRAM_URL, ADDRESS, MAP_URL, MAP_EMBED } from "@/lib/site";
import { Reveal, Eyebrow } from "./Reveal";
import { BookingForm } from "./BookingForm";

const Contact = ({ href, icon: Icon, label, value, testid, ext }) => (
  <a href={href} data-testid={testid} {...(ext ? { target: "_blank", rel: "noopener noreferrer" } : {})} className="group flex items-center gap-5 border-b border-white/10 py-5 transition-colors hover:text-brand">
    <span className="flex h-12 w-12 items-center justify-center border border-white/15 text-brand transition-colors group-hover:bg-brand group-hover:text-white"><Icon className="h-5 w-5" /></span>
    <span>
      <span className="block text-xs uppercase tracking-[0.2em] text-neutral-500">{label}</span>
      <span className="block font-display text-2xl tracking-wide text-white">{value}</span>
    </span>
  </a>
);

export const Booking = ({ defaultService, asPage = false }) => (
  <section id="rezervasyon" data-testid="booking-section" className="border-t border-white/10 bg-surface">
    <div className="mx-auto grid max-w-7xl grid-cols-1 gap-16 px-5 py-24 md:px-8 md:py-32 lg:grid-cols-[1.25fr_1fr]">
      <Reveal>
        {!asPage && <><Eyebrow>Rezervasyon</Eyebrow>
        <h2 className="font-display text-5xl uppercase leading-none text-white md:text-7xl">Tarihini seç, parkurda buluşalım.</h2></>}
        <p className="mb-10 mt-5 max-w-lg text-neutral-400">Hizmeti ve günü seç, bilgilerini bırak. Talebin bize ulaşır, uygunluğu teyit edip sana dönelim.</p>
        <BookingForm defaultService={defaultService} />
      </Reveal>
      <Reveal delay={0.1}>
        <div className={asPage ? "" : "lg:pt-24"}>
          <h3 className="font-display text-3xl uppercase text-white">Hemen ulaş</h3>
          <div className="mt-4 border-t border-white/10">
            <Contact href={WA_DEFAULT} ext icon={MessageCircle} label="WhatsApp" value={PHONE_DISPLAY} testid="contact-whatsapp-link" />
            <Contact href={PHONE_TEL} icon={Phone} label="Telefon" value={PHONE_DISPLAY} testid="contact-phone-link" />
            <Contact href={INSTAGRAM_URL} ext icon={Instagram} label="Instagram" value="@fxmotorsporlari" testid="contact-instagram-link" />
            <Contact href={MAP_URL} ext icon={MapPin} label="Adres" value={ADDRESS} testid="contact-map-link" />
          </div>
          <div className="mt-8 aspect-[4/3] w-full overflow-hidden border border-white/10">
            <iframe title="FX Motor Sporları konum — Çekmeköy / Ömerli" data-testid="contact-map-embed" src={MAP_EMBED} className="h-full w-full grayscale invert-[0.9]" loading="lazy" referrerPolicy="no-referrer-when-downgrade" />
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
